import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useUpdateBadgeImage, useFetchBadgeImagePlaylists } from 'actions/badges';
import filterObject from 'utils/filterObject';
import Panel from 'components/Panel';
import Text from 'components/Text';
import Stack from 'components/Stack';
import EmptyStateController from 'components/EmptyStateController';
import Button from 'components/Button';
import Card from 'components/Card';
import Modal from 'components/Modal';
import ModalHeadline from 'components/ModalHeadline';
import StickyButtonPanel from 'components/StickyButtonPanel';
var EditConfirmationModal = function EditConfirmationModal(_ref) {
  var _associatedPlaylists$;
  var imageId = _ref.imageId,
    selectedFile = _ref.selectedFile,
    badgeImageData = _ref.badgeImageData,
    onUpload = _ref.onUpload,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm,
    parentPlaylistId = _ref.parentPlaylistId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isReplaceMode = !!selectedFile;
  var _useFetchBadgeImagePl = useFetchBadgeImagePlaylists({
      id: imageId
    }),
    isFetchLoading = _useFetchBadgeImagePl.isLoading,
    associatedPlaylists = _useFetchBadgeImagePl.items;
  var _useUpdateBadgeImage = useUpdateBadgeImage({
      badgeImageId: imageId,
      parentPlaylistIds: associatedPlaylists === null || associatedPlaylists === void 0 ? void 0 : associatedPlaylists.map(function (playlist) {
        return playlist.id;
      }),
      hasSuccessAlert: true
    }),
    isUpdateLoading = _useUpdateBadgeImage.isLoading,
    updateBadgeImage = _useUpdateBadgeImage.updateBadgeImage;

  // Only show associated playlists if the badge image is associated with more than one playlist
  // Or with one playlist which is different than the playlist which user has currently opened
  var isAssociated = (associatedPlaylists === null || associatedPlaylists === void 0 ? void 0 : associatedPlaylists.length) === 1 ? ((_associatedPlaylists$ = associatedPlaylists[0]) === null || _associatedPlaylists$ === void 0 ? void 0 : _associatedPlaylists$.id) !== parentPlaylistId : (associatedPlaylists === null || associatedPlaylists === void 0 ? void 0 : associatedPlaylists.length) > 1;
  var titleId = 'edit-badge-image-confirmation-dialog-title';
  var modalTitle = isReplaceMode ? t('actions_replace_badge_image') : t('actions_edit_badge_image');
  var isLoading = isUpdateLoading || isFetchLoading;
  var handleConfirm = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var cleanedData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isReplaceMode) {
              _context.next = 5;
              break;
            }
            _context.next = 3;
            return onUpload(badgeImageData);
          case 3:
            _context.next = 8;
            break;
          case 5:
            cleanedData = filterObject({
              alternativeText: badgeImageData === null || badgeImageData === void 0 ? void 0 : badgeImageData.imageAlternativeText,
              style: badgeImageData === null || badgeImageData === void 0 ? void 0 : badgeImageData.style
            }); // Only update alt text or style, do not replace file
            _context.next = 8;
            return updateBadgeImage(cleanedData);
          case 8:
            onConfirm();
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleConfirm() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Modal, {
    "aria-labelledby": titleId,
    onRequestClose: onClose,
    id: "edit-badge-image-confirmation-dialog"
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "raised",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement(ModalHeadline, {
    sticky: true,
    title: modalTitle,
    titleId: titleId,
    onClose: onClose
  }), /*#__PURE__*/React.createElement(EmptyStateController, {
    isLoading: isFetchLoading
  }, /*#__PURE__*/React.createElement(Panel, null, isAssociated && /*#__PURE__*/React.createElement(React.Fragment, null, isReplaceMode ? t('modal_confirm_replace_badge_image_used_in_playlists', {
    count: associatedPlaylists.length
  }) : t('modal_confirm_edit_badge_image_used_in_playlists', {
    count: associatedPlaylists.length
  }), /*#__PURE__*/React.createElement("br", null)), isReplaceMode ? t('modal_confirm_replace_badge_image') : t('modal_confirm_edit_badge_image')), isAssociated && /*#__PURE__*/React.createElement(Panel, {
    flush: "top"
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    as: "p",
    mb: "xs"
  }, t('property_associated_playlists_colon')), /*#__PURE__*/React.createElement(Stack, {
    spacing: "xxs"
  }, associatedPlaylists.map(function (playlist) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: playlist.id
    }, playlist.name);
  })))), /*#__PURE__*/React.createElement(StickyButtonPanel, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose
  }, t('actions_cancel')), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    isLoading: isLoading,
    onClick: handleConfirm
  }, t('actions_confirm')))));
};
export default EditConfirmationModal;